import { Button } from '@mantine/core';
import { useTranslationAdminDashboard } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { ButtonWrapper } from '@dealstack/frontend/app/pages/Project/DealSettings/Classifiers/styled';

interface Props {
	onCancel: () => void;
	onSave: () => Promise<void>;
}

export const DrawerSubmission = ({ onCancel, onSave }: Props) => {
	const tAdminDashboard = useTranslationAdminDashboard();
	return (
		<ButtonWrapper>
			<Button variant="filled" onClick={async () => await onSave()}>
				{tAdminDashboard('classifier.side-bar.save')}
			</Button>
			<Button variant="ghost" onClick={() => onCancel()}>
				{tAdminDashboard('classifier.side-bar.cancel')}
			</Button>
		</ButtonWrapper>
	);
};
